class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    if (this.buttonClose) {
      this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));
    }

    // ❶: Interaktionen IM Dialog dürfen das Modal NICHT schließen
    const stop = (e) => {
      e.stopPropagation();
      // Manche Modal-Basen hören auf 'click' am Host – sicherheitshalber auch immediate stoppen:
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    };
    // wrapper + content (redundant sicher)
    this.wrapper?.addEventListener("mousedown", stop);
    this.wrapper?.addEventListener("mouseup", stop);
    this.wrapper?.addEventListener("click", stop);
    this.wrapper?.addEventListener("touchstart", stop, { passive: true });
    this.wrapper?.addEventListener("touchend", stop);

    this.content?.addEventListener("mousedown", stop);
    this.content?.addEventListener("mouseup", stop);
    this.content?.addEventListener("click", stop);
    this.content?.addEventListener("touchstart", stop, { passive: true });
    this.content?.addEventListener("touchend", stop);

    // ❷: Backdrop-Klick explizit behandeln (nur schließen, wenn direkt der Host geklickt wird)
    this.addEventListener("mousedown", (e) => {
      if (e.target === this) this.closeNewsletter();
    });
    this.addEventListener("click", (e) => {
      if (e.target === this) this.closeNewsletter();
    });

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form") || this.querySelector(".js-newsletter-form");
    this.wrapper = this.querySelector(".newsletter-popup__wrapper");
    this.content = this.querySelector(".newsletter-popup__content");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
    this.errorEl = this.querySelector(".form__message--error");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true");
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }
    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");
    const observer = new MutationObserver((mutations) => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;
      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");
      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });
    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
      }
    }, this.delay);
  }

  onSubscribe(e) {
    // Pflicht: Marketing-Checkbox muss angehakt sein
    const consent = this.form?.querySelector('input[name="customer[accepts_marketing]"][type="checkbox"]');
    if (!consent || !consent.checked) {
      e.preventDefault();
      if (this.errorEl) {
        this.errorEl.textContent = "Bitte bestätige die Newsletter-Einwilligung.";
        this.errorEl.hidden = false;
      } else {
        alert("Bitte bestätige die Newsletter-Einwilligung.");
      }
      return;
    }

    // Fehler zurücksetzen
    if (this.errorEl) {
      this.errorEl.hidden = true;
      this.errorEl.textContent = "";
    }

    // Cookie nur setzen, wenn Opt-in gegeben ist
    setCookie("newsletter-subscribed", "true");
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);